/* eslint-disable react/react-in-jsx-scope */
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	Img,
	Link,
	Text,
} from "@chakra-ui/react";

// eslint-disable-next-line arrow-body-style
const ThePrivateEquityBlog = () => {
	return (
		<>
			{/* members */}
			<Flex
				as="section"
				flexDirection="column"
				overflow="hidden"
				justify="center"
				height={{ xs: "450px", sm: "300px" }}
				minH={{ xs: "450px", sm: "300px" }}
				maxH="450px"
				pos="relative"
			>
				<Img
					pos="absolute"
					objectFit="cover"
					src="/jpg/blogBanner.jpg"
					alt="members-hero"
					height="100%"
					width="100%"
				/>
				<Box
					bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
					pos="absolute"
					height="100%"
					width="100%"
					opacity="0.7"
				/>
				<Container
					display="flex"
					as="section"
					maxW="container.xl"
					position="relative"
					zIndex="1"
					flexDirection="column"
				>
					<Flex
						alignItems={{ xs: "flex-start", md: "flex-start" }}
						justifyContent="center"
						columnGap="24px"
						justifyItems="center"
						width="100%"
						display="flex"
						as="section"
						rowGap="30px"
						flexDir={{
							xs: "column",
							md: "row",
						}}
					>
						<Flex flexDir="column" rowGap="16px">
							<Heading
								color="white"
								fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
								fontWeight="800"
								lineHeight={{ xs: "35px", lg: "83px" }}
							>
								#TheContext
							</Heading>
						</Flex>
						<Box
							w="1.5px"
							h={{ xs: "100%" }}
							bgColor="white"
							display={{ xs: "none", md: "block" }}
						/>
						<Box
							w={{ xs: "70%", sm: "60%" }}
							h="1.5px"
							bgColor="white"
							display={{ xs: "block", md: "none" }}
						/>
						{/*  */}
						<Heading
							as="h1"
							mb={{ xs: "10px", md: "20px" }}
							variant="reportCardTitle"
							fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
							color="white"
							lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
						>
							Private Equity Exits in India: The golden key to unlocking value
						</Heading>
					</Flex>
				</Container>
			</Flex>
			<Container
				as="section"
				maxW="container.xl"
				pb="80px"
				minH="420px"
				display={{ xs: "flex", md: "inherit" }}
				flexDirection="column"
			>
				<Flex
					flexDir={{ xs: "column-reverse", md: "row" }}
					px={{ xs: "8px", md: "0px" }}
					mt={{ xs: "32px", md: "80px" }}
				>
					<Flex
						w={{ xs: "100%", md: "27%" }}
						mt={{ xs: "32px", md: "0px" }}
						flexDir="column"
						rowGap="16px"
						mr={{ xs: "0px", md: "40px" }}
						ml={{ xs: "0px", sm: "10px" }}
						mb={{ xs: "16px", md: "8px" }}
					>
						<Heading
							fontSize="22px"
							lineHeight="22px"
							textAlign={{ xs: "center", sm: "left" }}
						>
							Follow the Authors
						</Heading>
						<Box
							w="100%"
							h="1.5px"
							bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
							my="8px"
						/>
						{[
							{
								name: "Ajay Kumar",
								position: "Executive Director Price Waterhouse & Co LLP",
								image:
									"https://static.levocdn.com/WGLBUT82/AajyK-LkpnHyTo6Ers.png",
							},
							{
								name: "Himanshu Mandavia",
								position: "Partner, Price Waterhouse & Co LLP",
								image:
									"https://static.levocdn.com/WGLBUT82/Himanshuphoto-01TmtMvciCAQ.png",
							},
						].map((item, index) => (
							<Flex
								key={index}
								flexDir={{ xs: "column", sm: "row", md: "column" }}
								columnGap="20px"
								rowGap="16px"
							>
								<Flex
									flexDir="column"
									alignItems={{ xs: "center", sm: "flex-start" }}
									rowGap="8px"
								>
									<Box boxSize="95px" borderRadius="50%" overflow="hidden">
										<Avatar
											name={item.name}
											w="100%"
											h="100%"
											src={item.image}
											objectFit="cover"
										/>
									</Box>
									<Flex flexDir="column" rowGap="4px">
										<Heading
											variant="blogQuestion"
											textAlign={{ xs: "center", sm: "left" }}
										>
											{item.name}
										</Heading>
										<Text
											variant="blogAnswer"
											textAlign={{ xs: "center", sm: "left" }}
											fontStyle="italic"
										>
											{item.position}
										</Text>
									</Flex>
								</Flex>
							</Flex>
						))}
					</Flex>

					<Box w={{ xs: "100%", md: "73%" }}>
						<Text variant="blogAnswer" mb="20px">
							A well-known quote on life journeys says “Focus on the journey,
							not the destination. Joy is found not in finishing an activity but
							in doing it.” However, as far as private equity (PE) investors are
							concerned, the joy for their clients as well as teams are
							inextricably linked to the destination of their investment
							journey, i.e., exits. The PE industry in India is becoming a
							relevant reference point in the global PE ecosystem - while the
							first decade of the twenty-first century saw the foundations of
							the PE / VC investment domain starting to take root in India, the
							next decade has been an era of expansion and coming of age for the
							private investment space. However, whether the Indian market was
							mature enough to provide a robust exit pipeline for PE investors
							was a question that was discussed quite often. Thankfully, the
							experience of the past few years has provided quite a positive
							answer to this question and the value of exits has jumped
							significantly, with the deal value in 2023 being more than double
							that of 2019. While the overall deal flow globally has been
							challenging, the deal value as well as deal volume has seen
							significant increase in India.
						</Text>
						<Box my="16px">
							<Text variant="blogAnswer">
								As regards the modes of exits, investors have been able to work
								through various modes including IPOs, strategic sales and
								secondary sales. The IPO market especially has turned attractive
								in India with a lot of companies being able to access the
								market, including the SME exchange. Indian investors have also
								showed a willingness to tread into offerings of new-age
								businesses even if they are not currently profitable. On the
								strategic sale side, while there has been a good traction on
								small and medium deals, larger deals (more than USD 500 mn) are
								still small in numbers. However, some of the large corporate
								houses in India have been keen to buyout some of the PE/VC
								backed new-age businesses and integrate them into their overall
								strategy of diversification. Secondary sales have been a
								constant mode of exit, especially for early stage investors, as
								larger private equity investors have enough dry powder to
								acquire meaningful stakes in businesses that are maturing in
								their journey. Corporate Venture Capital has also been a
								constant presence in India and while their overall share in deal
								value may have reduced, that is more attributable to many more
								investors coming into India.
							</Text>
						</Box>
						<Box my="16px">
							<Text variant="blogAnswer">
								As with all aspects, exit transactions in India come with their
								own needs of navigating through the tax and regulatory landscape
								in India. A typical secondary exit transaction needs to comply
								with valuation requirements under tax as well as exchange
								control regulations and while these requirements generally do
								not pose a significant hurdle, it does require some careful
								structuring to ensure that all the relevant boundaries are
								adhered to. This may be especially true in scenarios where there
								are multiple buyers and sellers with different residential
								status and may be a bit more complicated if the secondary round
								is tied with a primary fund-raise as well. For transactions with
								non-resident sellers, the tax withholding aspects in India
								become very important and negotiations on tax aspects in the
								share purchase agreements can become an intense process. While
								the tax rates on long-term capital gains for non-residents have
								recently increased slightly, the rates for resident investors
								have been reduced meaningfully and that has reduced the need for
								some of the complicated maneuvering on that side.
							</Text>
						</Box>
						<Box my="16px">
							<Text variant="blogAnswer">
								As far as companies going IPO are concerned, there are a whole
								host of issues that investors need to be mindful of, especially
								since companies need to go through a process of capital
								restructuring to meet the IPO requirements. This can involve
								corporate processes such as split of shares, bonus issuances,
								conversion of preference shares into equity, etc., and each of
								which have related tax and regulatory implications that need
								consideration. Also, the process of converting shares from
								physical form to electronic form can result into certain tax
								consequences that need to be handled carefully. For investors
								holding shares in a company that is potentially looking at an
								IPO, the decision to sell pre-IPO or participate in the OFS or
								to wait till shares are listed may need to be evaluated
								considering related tax consequences as well.
							</Text>
						</Box>
						<Box my="16px">
							<Text variant="blogAnswer">
								While the tax and regulatory landscape around PE exits can look
								a bit daunting, a bit of careful preparation can allow investors
								to maximize their share of the significant opportunity that
								exists in India to earn attractive returns on investments.
							</Text>
						</Box>
					</Box>
				</Flex>

				<Heading
					variant="blogQuestion"
					lineHeight="30px"
					pt="16px"
					fontStyle="italic"
					p="12px 12px 0px"
				>
					Content in this section is curated by team IVCA. To share feedback,
					connect with&nbsp;
					{/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
					<Link
						href="mailto:paromita.sinha@ivca.in"
						target="_blank"
						style={{ color: "blue", textDecoration: "underline" }}
					>
						paromita.sinha@ivca.in
					</Link>
				</Heading>
			</Container>
		</>
	);
};

export default ThePrivateEquityBlog;
